/**
 * Currently a plcaeholder. To be implemented as a rich change log of data state. Since actions and payloads are logged here on every dispatch, a local cache of recent actions dispatched would allow for implementation of a rewind/cherry-pick/rollback style functionality.
 * @param getState
 * @param dispatch
 * @returns {function(*): function(*=): *}
 */
const crudLogger = ({getState, dispatch}) => {
    return next => action => {
        console.log(action);
        // TODO: Store said action in db collection
        return next(action);
    }
};
export default crudLogger;